import styled from "styled-components";
import AboutMe from "../components/AboutMe.js/OMnie";
import Contact from "../components/Contact";
import LandingPage from "../components/LandingPage";
import Navbar from "../components/Navbar";
import Portfolio from "../components/Portfolio";
import Timeline from "../components/Timeline";
import {useTranslation} from "react-i18next"
const OnePage = () => {


 const { t } = useTranslation();
  return (
    <>
      <LandingPage t={t} />
      <AboutMe  t={t}/>
      <Timeline t={t}/>
      <Portfolio t={t}/>
      <Contact t={t}/>
    </>
  );
};
export default OnePage;
